import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=6f1ce978&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=6f1ce978&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ce978",
  null
  
)

export default component.exports